import { Row } from "@tanstack/react-table";
import { Badge } from "@pushpress/pushpress-ui";
import SubscriptionPopover from "./SubscriptionPopover";
import { getStatusFormat } from "../../helpers";
import StatusBadge from "./StatusBadge";
import { PEOPLE_TYPE, PeopleType } from "../../types";

export default function MobileNameCellContent({
  row,
  peopleType,
}: {
  row: Row<any>;
  peopleType: PeopleType;
}) {
  const status =
    peopleType === PEOPLE_TYPE.MEMBERS
      ? row.original.subscriptions?.[0]?.status
      : peopleType === PEOPLE_TYPE.LEADS
        ? row.getValue("leadStatus")
        : undefined;
  return (
    <>
      {peopleType !== PEOPLE_TYPE.STAFF && (
        <div className="tw-break-words sm:tw-hidden tw-text-xs tw-text-neutral-600 tw-flex tw-items-center tw-gap-1">
          <div className="tw-truncate tw-max-w-[130px]">
            {row.original.subscriptions?.[0]?.name || "--"}
          </div>
          {row.original.subscriptions?.length > 1 && (
            <SubscriptionPopover
              label={row.original.subscriptions?.length - 1}
              subscriptions={row.original.subscriptions.slice(1, 10)}
            />
          )}
        </div>
      )}
      <div className="sm:tw-hidden tw-flex tw-gap-2 tw-mt-1">
        {peopleType !== PEOPLE_TYPE.LEADS && (
          <Badge variant="neutral" size="sm">
            {getStatusFormat(row.getValue("membershipRole"))}
          </Badge>
        )}
        {peopleType !== PEOPLE_TYPE.STAFF && (
          <StatusBadge peopleType={peopleType} status={status} isMobile />
        )}
      </div>
    </>
  );
}
